<template>
    <img :src="src" alt="Optimized Tech" class="app-brand" :style="{ height: `${height}px` }" />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useTheme } from "vuetify";

type Props = { iconOnly?: boolean; height?: number };
const props = withDefaults(defineProps<Props>(), { iconOnly: false, height: 30 });

const theme = useTheme();
const src = computed(() => {
    if (props.iconOnly) return "/img/tricolorcircle.svg";
    return theme.current.value.dark ? "/img/logo-dark.svg" : "/img/logo.svg";
});
</script>

<style lang="scss">
.app-brand {
    width: auto;
    display: block;
}
</style>
